import { getAssetUrl } from "@/utils";
import { BackgroundImage, Title } from "@mantine/core";

export function StaticPageLayout({ title }: { title: string }): JSX.Element {
  return (
    <BackgroundImage src={getAssetUrl("/page-header-bg.webp")}>
      <Title
        order={1}
        className="text-[34px] text-center !text-blue-9 py-5 md:py-12 capitalize"
      >
        {title}
      </Title>
    </BackgroundImage>
  );
}
